import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Link, Redirect } from 'react-router-dom';
import { notification } from "antd";

import Select, { components } from 'react-select';
import moment from 'moment';

import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import './date-range.css'
import { Modal } from "react-bootstrap";
import { Pagination, Tooltip } from 'antd';

import { useTheme } from "./theme-provider.js";
import { useAuthData } from "./auth-provider.js";
import { io } from "socket.io-client";
import { setCookie, getCookie } from '../common_component/cookie.js';

import { TbProgress } from "react-icons/tb";
import { Timeline } from 'antd';
import { ClockCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import StatusBadge from "../common_component/StatusBadge.js";
import PageError from "../common_component/PageError.js";
import PageLoader from "../common_component/PageLoader.js";
import formatNumber from "../common_component/formatNumber.js";

const formatNumberOptions = {
    decimalPlaces: 2,
    removeTrailingZeros: true,
    currencyFormat: '1,234,567.89'
};

const statusTypeArray = ["ECOMMERCE_ORDER_PENDING", "ECOMMERCE_ORDER_CONFIRMED", "ECOMMERCE_ORDER_FAILURE", "ECOMMERCE_ORDER_INVOICED", "ECOMMERCE_ORDER_CANCELLED", "ECOMMERCE_ORDER_UNDER_PROCESSING", "ECOMMERCE_ORDER_PACKED", "ECOMMERCE_ORDER_SHIPPED", "ECOMMERCE_ORDER_DELIVERED"]

function EcommerceOrders() {
    const daterange_picker_ref = useRef();
    const [state, setstate] = useState(2);
    const { theme, dropdownStyleDark } = useTheme()
    const [statusType, setStatusType] = useState({ label: "All", value: "All" });

    const [startDate, setStartDate] = useState(moment.utc().subtract(6, "days").format("YYYY-MM-DD"))
    const [endDate, setEndDate] = useState(moment.utc().format("YYYY-MM-DD"))
    const [timezone_change, set_timezone_change] = useState("+00:00");
    const [ecommerceOrderList, setEcommerceOrderList] = useState([]);
    const [ecommerceOrderListApiState, setEcommerceOrderListApiState] = useState(false)
    const [totalListLength, setTotalListLength] = useState(0);

    const [searchValue, setSearchValue] = useState('');
    const [itemDetailsModalShow, setItemDetailsModalShow] = useState(false)
    const [itemArrayIndex, setItemArrayIndex] = useState(null)

    const [progressModalShow, setProgressModalShow] = useState(false)
    const [progressStatus, setProgressStatus] = useState(null)
    const [flowApiState, setFlowApiState] = useState(false)

    const [current_page, setCurrent_page] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const apiController = useRef(new AbortController());

    const socketRef = useRef(null);

    const search_length = 2;

    const presets = [
        { label: 'Today', start: new Date(), end: new Date() },
        { label: 'Last 7 days', start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date() },
        { label: 'Last 30 days', start: new Date(new Date().setDate(new Date().getDate() - 30)), end: new Date() },
        { label: 'Last 90 days', start: new Date(new Date().setDate(new Date().getDate() - 90)), end: new Date() }
    ];

    var page_name = "ecommerce-orders";

    const { user, read, write, visibility, organization_id } = useAuthData(page_name);

    async function getTimezoneInformation() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-organization-timezone-information`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        if (body.operation === "success") {
            if (body.data.length > 0) {
                if (body.data[0].timezone_value != "" && body.data[0].timezone_value != null) {
                    const timezone = body.data[0].timezone_value;
                    set_timezone_change(timezone);
                    setStartDate(moment().utcOffset(timezone).subtract(6, "days").format("YYYY-MM-DD"));
                    setEndDate(moment().utcOffset(timezone).format("YYYY-MM-DD"));
                }
                else {
                    setStartDate(moment.utc().subtract(6, "days").format("YYYY-MM-DD"));
                    setEndDate(moment.utc().format("YYYY-MM-DD"));
                }
            }
            else {
                setStartDate(moment.utc().subtract(6, "days").format("YYYY-MM-DD"));
                setEndDate(moment.utc().format("YYYY-MM-DD"));
            }
        }
        else {
            throw "timezone api error"
        }
    }

    async function getEcommerceOrders(sd, ed, page_number, size, search_val, st) {
        try {
            if (ecommerceOrderListApiState) {
                apiController.current.abort()
                apiController.current = new AbortController()
            }
            setEcommerceOrderListApiState(true)
            // setDealerCollectionList([]);
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-all-ecommerce-order`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "start_date": sd, "end_date": ed, "current_page": page_number, "rows_per_page": size, "search_value": search_val, "status_type": st, "page_name": page_name, "flag": "collection_list", "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();
            if (body.operation !== "success") throw "get ecommerce order list api error"

            setEcommerceOrderList(body.data.list)
            setTotalListLength(body.data.count)
            setEcommerceOrderListApiState(false)
        }
        catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    const getProgressByStatus = async (order_id) => {
        setFlowApiState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-ecommerce-timeline-by-order`, { method: 'POST', body: JSON.stringify({ "email": user.email, "order_id": order_id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.operation === "success") {
            setProgressStatus(body.data)
        }
        else {
            throw "ecommerce progress api error"
        }
        setFlowApiState(false)
    }

    const showOrderNotification = (data) => {
        notification.open({
            message: `🛒 New Order Confirmed - ${data.order_number}`,
            description: (
                <div>
                    <b>Order ID:</b> {data.order_id}
                    <br />
                    <span>{data.message}</span>
                </div>
            ),
            placement: "topRight",
            duration: 5,
        });
    };


    const playBeepSound = () => {
        try {
            const audioContext = new (window.AudioContext || window.webkitAudioContext)();

            // Check if context is suspended and resume it
            if (audioContext.state === 'suspended') {
                audioContext.resume();
            }

            const oscillator = audioContext.createOscillator();
            const gainNode = audioContext.createGain();

            oscillator.connect(gainNode);
            gainNode.connect(audioContext.destination);

            oscillator.type = 'sine'; // 'sine' is generally clear; 'square' can be sharper
            oscillator.frequency.value = 880; // Increase frequency to a higher, more distinct pitch (e.g., 880Hz for A5)
            gainNode.gain.setValueAtTime(0.7, audioContext.currentTime); // Increase initial volume (e.g., to 0.7 or 0.8)

            const duration = 0.25; // Increase duration to 0.25 seconds (250ms)

            oscillator.start();
            oscillator.stop(audioContext.currentTime + duration);

            // Stronger fade out for a crisp stop
            gainNode.gain.exponentialRampToValueAtTime(0.001, audioContext.currentTime + duration);

            oscillator.onended = () => {
                audioContext.close();
            };

        } catch (e) {
            console.error("Web Audio API not supported or error playing sound:", e);
        }
    };

    useEffect(() => {
        if (user && user.email) {
            const socket = io(process.env.REACT_APP_SOCKET_SERVER_URL, {
                transports: ["websocket"],
                forceNew: true,
            });

            socketRef.current = socket;
            // Join room when page opens
            socket.emit("join_admin_orders_page", { organization_id });

            socket.on("new_order_confirmed", (data) => {
                console.log("Order notification:", data);

                playBeepSound();

                // 🔄 Refresh order list
                getEcommerceOrders(startDate, endDate, current_page, pageSize, searchValue, statusType.value);

                showOrderNotification(data);
            });

            return () => {
                socket.off("new_order_confirmed");
            };
        }
    }, [user, organization_id]);

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {

            let p1 = getTimezoneInformation();
            let p2 = getEcommerceOrders(startDate, endDate, current_page, pageSize, searchValue, statusType.value);
            // let p2 = getUserRole();

            Promise.all([p1, p2])
                .then(() => {
                    setstate(1)
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(3)
                    console.log(err)

                })
        }
    }, [user, visibility, read, write])

    useEffect(() => {
        if (state == 1) {
            getEcommerceOrders(startDate, endDate, current_page, pageSize, searchValue, statusType.value)
        }
    }, [startDate, endDate, current_page, pageSize, searchValue, statusType.value])

    return (
        <>
            <div>
                <div className="d-flex flex-stack">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Ecommerce Orders</h1>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <Tooltip title="SpotERP Docs" >
                            <a
                                href={`${process.env.REACT_APP_SPOTERP_DOCS}/ecommerce/ecommerce_orders`}
                                className='btn btn-light-primary py-2 px-3'
                                target="_blank"
                            >
                                <i className="bi bi-journal-text fs-1 px-0"></i>
                            </a>
                        </Tooltip>
                    </div>
                </div>
                <div>
                    {
                        state === 1 ?
                            <>
                                <div className="row gx-0 gap-5 m-2">
                                    <div className='col-md-3'>
                                        {(startDate !== "" && endDate != "") &&
                                            <div className="d-flex align-items-center gap-5 mx-5 my-2">
                                                <DateRangePickerComponent
                                                    ref={daterange_picker_ref}
                                                    allowEdit={false}
                                                    focus={(e) => {
                                                        //console.log(e);
                                                        daterange_picker_ref.current.show()
                                                    }}
                                                    delayUpdate={true}
                                                    presets={presets}
                                                    change={(e) => {
                                                        setStartDate(moment(e.startDate).format("YYYY-MM-DD"));
                                                        setEndDate(moment(e.endDate).format("YYYY-MM-DD"));
                                                    }}
                                                    startDate={new Date(startDate)}
                                                    endDate={new Date(endDate)}
                                                    max={new Date().toISOString().split('T')[0]}
                                                />
                                            </div>
                                        }
                                    </div>
                                    <div className='col-md-3'>
                                        <Select
                                            options={[{ label: "All", value: "All" }, ...statusTypeArray.map(x => { return { label: x.replace("ECOMMERCE_ORDER", "").replace("_", "").toLowerCase().replace(/_/g, ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()), value: x } })]}
                                            onChange={(event) => { setStatusType(event); }}
                                            value={statusType}
                                            placeholder="Select Type..."
                                            styles={theme === 'dark' ? dropdownStyleDark : {}}
                                        />
                                    </div>
                                </div>
                                <div className="card mb-5 mb-xl-8">
                                    <div className="card-body py-3">
                                        <div className='mb-5'>
                                            <input type="text" className='form-control fw-bold border border-primary' value={searchValue} onChange={(e) => { setSearchValue(e.target.value) }} placeholder='Search Orders...' />
                                        </div>
                                        <div className="d-flex flex-column align-items-center" style={{ minHeight: "50vh" }}>
                                            <div className="mb-5 d-flex justify-content-center">
                                                <Pagination
                                                    total={totalListLength}
                                                    onChange={(page, pageSize) => {
                                                        setCurrent_page(page);
                                                        setPageSize(pageSize);
                                                    }}
                                                    showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                                                    defaultPageSize={pageSize}
                                                    defaultCurrent={current_page}
                                                    showSizeChanger={true}
                                                />
                                            </div>
                                            <div className='overflow-auto w-100 flex-grow-1'>
                                                <table className="table table-row-bordered text-nowrap table-row-gray-100 align-middle gs-0 gy-3 h-preserve-whitespace" style={{ minWidth: "1000px" }}>
                                                    <thead>
                                                        <tr className="fw-bold text-muted">
                                                            {/* <th className="min-w-150px">Order Id</th> */}
                                                            <th className="min-w-120px">Order No.</th>
                                                            <th className="min-w-120px">Contact Details</th>
                                                            <th className="min-w-120px">Item</th>
                                                            <th className="min-w-120px">Order Amount</th>
                                                            <th className="min-w-120px">Shipping Amount</th>
                                                            {/* <th className="min-w-120px">Payment Mode</th> */}
                                                            <th className="min-w-80px">Payment Gateway</th>
                                                            <th className="min-w-120px">Order Date</th>
                                                            <th className="min-w-80px">Invoices</th>
                                                            <th className="min-w-120px">Status</th>
                                                            <th className="min-w-120px">Timeline</th>
                                                            <th className="min-w-50px text-end">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            ecommerceOrderListApiState ?
                                                                <tr>
                                                                    <td colSpan={10} className="text-center pt-10">
                                                                        <div className="spinner-border text-primary"></div>
                                                                    </td>
                                                                </tr>
                                                                :
                                                                ecommerceOrderList.length > 0 ?
                                                                    ecommerceOrderList.map((obj3, indx3) => {
                                                                        return (
                                                                            <tr key={indx3}>
                                                                                {/* <td><span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj3.ref_order_id}</span></td> */}
                                                                                <td>
                                                                                    <span className="text-dark fw-bold text-hover-primary fs-6">
                                                                                        {obj3.order_number}
                                                                                    </span>
                                                                                    <br />
                                                                                    <span className="text-muted fs-8" style={{ wordBreak: 'break-all' }}>
                                                                                        {obj3.ref_order_id}
                                                                                    </span>
                                                                                </td>
                                                                                <td>
                                                                                    <span className="text-dark fw-semibold fs-6">
                                                                                        {obj3.billing_address.first_name} {obj3.billing_address.last_name}
                                                                                    </span>
                                                                                    <br />
                                                                                    <span className="text-muted fs-8">
                                                                                        {obj3.billing_address.email}, {obj3.billing_address.phone_number}
                                                                                    </span>
                                                                                </td>
                                                                                <td><button className="btn btn-sm btn-info fs-8 px-3 py-2 rounded" onClick={() => { setItemDetailsModalShow(true); setItemArrayIndex(indx3) }}>View</button></td>
                                                                                <td><span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj3.order_currency.currency_symbol}{formatNumber(obj3.order_amount, { ...formatNumberOptions, decimalPlaces: obj3.order_currency.decimal_place })}</span></td>
                                                                                <td><span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj3.order_currency.currency_symbol}{obj3.shipping_amount}</span></td>
                                                                                <td><span className="badge badge-primary">{obj3.payment_gateway}</span></td>
                                                                                <td><span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{moment(obj3.order_date).utcOffset(timezone_change).format("ll")}</span></td>
                                                                                <td>{obj3.associated_invoice_number.length ? obj3.associated_invoice_number.map((x, i) => (<span className="badge badge-light-info fs-6 m-1" key={i}>{x}</span>)) : <span className="text-gray-600">N/A</span>}</td>
                                                                                <td><StatusBadge status={obj3.order_status} entity={"ECOMMERCE_ORDER"} /></td>
                                                                                <td>
                                                                                    {(obj3.order_status !== "ECOMMERCE_ORDER_PENDING" && obj3.order_status !== "ECOMMERCE_ORDER_FAILURE") &&
                                                                                        <button style={{ backgroundColor: '#adb8f0', border: '1px solid #c0c0c0', borderRadius: '4px', padding: '5px 10px', cursor: 'pointer', transition: 'background-color 0.3s', }} onClick={() => { setProgressModalShow(true); getProgressByStatus(obj3.order_id) }}> <TbProgress /> </button>}</td>
                                                                                <td className="text-end">
                                                                                    <div className="dropdown">
                                                                                        <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                                                            <i className="fas fa-bars px-0"></i>
                                                                                        </button>
                                                                                        {
                                                                                            write &&
                                                                                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                                                <li className="py-1"><Link to={`/view-ecommerce-order/${obj3.order_id}`} className="dropdown-item">View details</Link></li>
                                                                                                {write == 1 && (obj3.order_status == "ECOMMERCE_ORDER_CONFIRMED") && <li className="py-1"><Link className="dropdown-item" to={`/view-ecommerce-order/${obj3.order_id}`}>Process to Warehouse</Link></li>}
                                                                                                {write == 1 && (obj3.order_status == "ECOMMERCE_ORDER_CONFIRMED") && <li className="py-1"><Link className="dropdown-item" to={`/view-ecommerce-order/${obj3.order_id}`}>Cancel Order</Link></li>}
                                                                                            </ul>
                                                                                        }
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                    :
                                                                    <tr>
                                                                        <td colSpan={10} className="text-center">
                                                                            <h3 className="text-muted pt-6">No data to be shown</h3>
                                                                        </td>
                                                                    </tr>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="mt-5 d-flex justify-content-center">
                                                <div className="card-toolbar">
                                                    <Pagination
                                                        total={totalListLength}
                                                        onChange={(page, pageSize) => {
                                                            setCurrent_page(page);
                                                            setPageSize(pageSize);
                                                        }}
                                                        showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                                                        defaultPageSize={pageSize}
                                                        defaultCurrent={current_page}
                                                        showSizeChanger={true}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            state === 2 ?
                                <PageLoader />
                                :
                                <PageError />
                    }
                </div>
            </div>

            <Modal show={itemDetailsModalShow} onHide={() => { setItemDetailsModalShow(false); }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Items</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setItemDetailsModalShow(false); }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div className="d-flex border-bottom">
                            <span className="col-8 fw-bold text-primary fs-2 d-block mb-1">Item Name</span>
                            <span className="col-4 text-center fw-bold text-primary fs-2 d-block mb-1">Quantity</span>
                        </div>
                        {
                            itemDetailsModalShow && ecommerceOrderList[itemArrayIndex].item_list.map((obj, indx) => (
                                <div className="d-flex py-3 border-bottom" key={obj.item_id}>
                                    <div className="col-8 d-flex flex-column">
                                        <span className="fs-3">{obj.item_name}</span>
                                        {
                                            obj.item_stock_type !== null &&
                                            <div>
                                                <span className={`badge ${obj.item_stock_type === "Track Serial Number" ? "badge-light-success" : obj.item_stock_type === "Track Batches" ? "badge-light-info" : "badge-light-primary"}`}>{obj.item_stock_type === "Track Serial Number" ? "Serial" : obj.item_stock_type === "Track Batches" ? "Batches" : "None"}</span>
                                            </div>
                                        }
                                    </div>
                                    <span className="col-4 text-center fs-3">{obj.quantity}</span>
                                </div>
                            ))
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { setItemDetailsModalShow(false) }}>Close</button>
                </Modal.Footer>
            </Modal>

            <Modal show={progressModalShow} onHide={() => { setProgressModalShow(false); setProgressStatus([]); }} centered>
                <Modal.Body>
                    {flowApiState === true && (
                        <div className="text-center">
                            <span>Loading...</span>
                            <svg width="50" height="15" viewBox="0 45 100 10">
                                <g transform="translate(20 50)"><circle cx="0" cy="0" r="6" fill="#e15b64"><animateTransform attributeName="transform" type="scale" begin="-0.375s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
                                <g transform="translate(40 50)"><circle cx="0" cy="0" r="6" fill="#f8b26a"><animateTransform attributeName="transform" type="scale" begin="-0.25s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
                                <g transform="translate(60 50)"><circle cx="0" cy="0" r="6" fill="#abbd81"><animateTransform attributeName="transform" type="scale" begin="-0.125s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
                                <g transform="translate(80 50)"><circle cx="0" cy="0" r="6" fill="#81a3bd"><animateTransform attributeName="transform" type="scale" begin="0s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
                            </svg>
                        </div>
                    )}

                    {flowApiState === false && (
                        <>
                            <div className="position-absolute top-0 end-0 p-5">
                                <div onClick={() => { setProgressModalShow(false); setProgressStatus([]) }} className="cursor-pointer">
                                    <i className="bi bi-x-circle fs-1 text-danger"></i>
                                </div>
                            </div>
                            <div className='container mt-6'>
                                {/* {
                                    progressStatus.ecom_delivery_challan_data &&
                                    progressStatus.ecom_delivery_challan_data.length > 0 &&
                                    progressStatus.ecom_delivery_challan_data.some(challan =>
                                        challan.ecom_delivery_challan_status_logs &&
                                        challan.ecom_delivery_challan_status_logs.some(obj => obj.delivery_challan_status === "DELIVERY_DISPATCHED" || obj.delivery_challan_status === "ECOMMERCE_DELIVERY_CHALLAN_DISPATCHED")
                                    ) && (
                                        <div className="alert alert-success mb-4">
                                            <strong>Flow Completed:</strong> The challan has been dispatched.
                                        </div>
                                    )
                                } */}
                                {
                                    progressStatus &&
                                    <Timeline
                                        items={
                                            (() => {
                                                let logsArray = []
                                                if (progressStatus.ecom_order_data) {
                                                    logsArray = [...logsArray, ...progressStatus.ecom_order_data.ecom_order_status_logs]
                                                }
                                                if (progressStatus.ecom_warehouse_processing_data) {
                                                    logsArray = [...logsArray, ...progressStatus.ecom_warehouse_processing_data.ecom_warehouse_processing_status_logs]
                                                }
                                                if (progressStatus.ecom_delivery_challan_data && progressStatus.ecom_delivery_challan_data.length) {
                                                    progressStatus.ecom_delivery_challan_data.forEach(dc => {
                                                        logsArray = [...logsArray, ...dc.ecom_delivery_challan_status_logs]
                                                    });
                                                }

                                                logsArray.sort((a, b) => {
                                                    if (moment(a.timestamp).isBefore(moment(b.timestamp))) {
                                                        return -1
                                                    } else return 1
                                                })

                                                let warehouseStage = false
                                                let challanStage = false
                                                let invoiceStage = false

                                                if (logsArray.find(obj => {
                                                    let status_key = Object.keys(obj).find(x => /_status/.test(x))
                                                    let status = obj[status_key]

                                                    return status === "ECOMMERCE_WAREHOUSE_PROCESSING_INIT"
                                                })) {
                                                    warehouseStage = true
                                                }

                                                if (logsArray.find(obj => {
                                                    let status_key = Object.keys(obj).find(x => /_status/.test(x))
                                                    let status = obj[status_key]

                                                    return status === "ECOMMERCE_DELIVERY_CHALLAN_DISPATCHED"
                                                })) {
                                                    challanStage = true
                                                }

                                                if (logsArray.find(obj => {
                                                    let status_key = Object.keys(obj).find(x => /_status/.test(x))
                                                    let status = obj[status_key]

                                                    return status === "ECOMMERCE_ORDER_INVOICED"
                                                })) {
                                                    invoiceStage = true
                                                }

                                                console.log(635, warehouseStage, challanStage, invoiceStage);

                                                const fa = logsArray.map(obj => {
                                                    let status_key = Object.keys(obj).find(x => /_status/.test(x))
                                                    let status = obj[status_key]

                                                    return (
                                                        {
                                                            color: "green",
                                                            dot: <CheckCircleOutlined />,
                                                            children: <div className="d-flex flex-wrap">
                                                                <div className="d-flex flex-column ps-3" style={{ maxWidth: "150px" }}>
                                                                    <StatusBadge status={status} entity={status.match(/^(ECOMMERCE_(ORDER|WAREHOUSE|DELIVERY_CHALLAN))/)[1]} />
                                                                    <p className="fw-mormal timeline-content text-muted mb-0">{obj.operation_message}</p>
                                                                </div>
                                                                <div className="d-flex flex-column align-items-center ps-5">
                                                                    <p className="fw-bold text-gray-800 fs-6 mb-0">Date</p>
                                                                    <p className="fw-bold text-gray-800 fs-6">{moment(obj.timestamp).utcOffset(timezone_change).format("lll")}</p>
                                                                </div>
                                                            </div>
                                                        }
                                                    )
                                                })

                                                if (!warehouseStage) {
                                                    fa.push(
                                                        {
                                                            color: "red",
                                                            dot: <ClockCircleOutlined />,
                                                            children: <div className="d-flex flex-wrap">
                                                                <div className="d-flex flex-column ps-3" style={{ maxWidth: "150px" }}>
                                                                    <p className="fw-bold text-muted mb-0">Warehouse Processing Pending</p>
                                                                </div>
                                                            </div>
                                                        }
                                                    )
                                                }

                                                if (!challanStage) {
                                                    fa.push(
                                                        {
                                                            color: "red",
                                                            dot: <ClockCircleOutlined />,
                                                            children: <div className="d-flex flex-wrap">
                                                                <div className="d-flex flex-column ps-3" style={{ maxWidth: "150px" }}>
                                                                    <p className="fw-bold text-muted mb-0">Delivery Challan Pending</p>
                                                                </div>
                                                            </div>
                                                        }
                                                    )
                                                }

                                                if (!invoiceStage) {
                                                    fa.push(
                                                        {
                                                            color: "red",
                                                            dot: <ClockCircleOutlined />,
                                                            children: <div className="d-flex flex-wrap">
                                                                <div className="d-flex flex-column ps-3" style={{ maxWidth: "150px" }}>
                                                                    <p className="fw-bold text-muted mb-0">Invoice Generation Pending</p>
                                                                </div>
                                                            </div>
                                                        }
                                                    )
                                                }

                                                return fa
                                            })()
                                        }
                                    />
                                }
                            </div>
                        </>
                    )}
                </Modal.Body>
            </Modal >
        </>
    );
}
export default EcommerceOrders;